import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kmb-timeline-lib',
  template: `
    <p>
      timeline-lib works!
    </p>
  `,
  styles: []
})
export class TimelineLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
